import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// Create axios instance
const axiosInstance = axios.create({
    timeout: 30000, // 30 seconds timeout
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        // Log requests in development/native mode
        if (Capacitor.isNativePlatform() || process.env.NODE_ENV === 'development') {
            console.log('API Request:', JSON.stringify({
                url: config.url,
                method: config.method,
                headers: config.headers,
                data: config.data
            }, null, 2));
        }
        
        // Ensure proper headers for CORS in native apps
        if (Capacitor.isNativePlatform()) {
            config.headers['Accept'] = 'application/json';
            // Remove any browser-specific headers that might cause issues
            delete config.headers['X-Requested-With'];
        }
        
        return config;
    },
    (error) => {
        console.error('Request interceptor error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        // Log successful responses
        if (Capacitor.isNativePlatform() || process.env.NODE_ENV === 'development') {
            console.log('API Response:', {
                url: response.config.url,
                status: response.status,
                data: response.data
            });
        }
        return response;
    },
    (error) => {
        // Enhanced error logging
        if (error.response) {
            // Server responded with error status
            console.error('API Error Response:', JSON.stringify({
                url: error.config?.url,
                status: error.response.status,
                statusText: error.response.statusText,
                data: error.response.data,
                headers: error.response.headers
            }, null, 2));
            
            // Handle specific error codes
            if (error.response.status === 0) {
                // Network error or CORS issue
                error.message = 'Network error. Please check your connection and try again.';
            } else if (error.response.status === 404) {
                error.message = 'API endpoint not found. Please contact support.';
            } else if (error.response.status === 500) {
                error.message = 'Server error. Please try again later.';
            }
        } else if (error.request) {
            // Request made but no response
            console.error('API No Response:', {
                url: error.config?.url,
                request: error.request,
                message: error.message
            });
            
            // Check if it's a network/CORS issue
            if (error.message === 'Network Error') {
                error.message = 'Unable to connect to the server. Please check your internet connection.';
            }
        } else {
            // Error in request configuration
            console.error('API Request Setup Error:', error.message);
        }
        
        return Promise.reject(error);
    }
);

export default axiosInstance;